(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compraxitems"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // 1. Lógica de los Hotspots
    const hotspots = document.querySelectorAll('.stl-hotspot');
    hotspots.forEach(spot => {
      const btn = spot.querySelector('.stl-hotspot-btn');
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const isActive = spot.classList.contains('is-active');
        hotspots.forEach(s => s.classList.remove('is-active'));
        if (!isActive) spot.classList.add('is-active');
      });
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.stl-hotspot')) {
        hotspots.forEach(s => s.classList.remove('is-active'));
      }
    });

    // 2. Lógica del Slider
    const sliderContainers = document.querySelectorAll('.stl-slider-container');
    
    sliderContainers.forEach(container => {
      const slider = container.querySelector('.stl-slider');
      const btnPrev = container.querySelector('.stl-prev');
      const btnNext = container.querySelector('.stl-next');
      const dots = container.querySelectorAll('.stl-dot');
      
      if(!slider || !btnNext) return; // Si solo hay 1 foto, no hay slider

      const updateDots = () => {
        const index = Math.round(slider.scrollLeft / slider.offsetWidth);
        dots.forEach((dot, i) => {
          dot.classList.toggle('active', i === index);
        });
      };

      btnNext.addEventListener('click', () => {
        slider.scrollBy({ left: slider.offsetWidth, behavior: 'smooth' });
      });

      btnPrev.addEventListener('click', () => {
        slider.scrollBy({ left: -slider.offsetWidth, behavior: 'smooth' });
      });

      dots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          const index = parseInt(e.target.dataset.index);
          slider.scrollTo({ left: slider.offsetWidth * index, behavior: 'smooth' });
        });
      });

      slider.addEventListener('scroll', updateDots, { passive: true });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
